import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { Box, Checkbox, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { ReactComponent as CheckIcon } from "@/common/Images/CheckIcon.svg";
import { ReactComponent as UnCheckIcon } from "@/common/Images/UnCheckIcon.svg";
import CommonButton from "@/views/CommonComponent/CommonButton";
import GuardianConsentTerms from "@/views/CommonComponent/GuardianConsentTerms";
import TitleBox from "@/views/CommonComponent/TitleBox";
import {
  SignInContentsBox,
  SignInRoot,
  InfoBox,
  ButtonContainer,
} from "./Styled/SignInStyled";

function GuardianConsent(props) {
  const { intl, authStore } = props;
  const history = useHistory();
  const [isGuardianConsentChecked, setIsGuardianConsentChecked] = useState(false);

  const goBackToUserInfoSettingWithState = (ageAgreedToUseUnder14 = false) => {
    const st = history.location.state;
    history.push("/userInfoSetting", {
      fromGuardianConsentReturn: true,
      ageAgreedToUseUnder14,
      isMemoryEnabled: st?.isMemoryEnabled,
      birthDate: st?.birthDate,
      nickname: st?.nickname,
      selectedGender: st?.selectedGender,
    });
  };

  const handleBack = () => {
    if (history.location.state?.from === "UserInfoSetting") {
      authStore.setAgeAgreedToUseUnder14(false);
      goBackToUserInfoSettingWithState(false);
      return;
    }
    history.goBack();
  };

  const handleSubmit = () => {
    authStore.setAgeAgreedToUseUnder14(isGuardianConsentChecked);

    if (history.location.state?.from === "UserInfoSetting") {
      goBackToUserInfoSettingWithState(isGuardianConsentChecked);
      return;
    }

    history.push("/signin/memory-consent", {
      notNewUser: history.location.state?.notNewUser,
      redirectUrl: history.location.state?.redirectUrl,
      deviceId: history.location.state?.deviceId,
      returnToPokoroSettingAfterProfile:
        history.location.state?.returnToPokoroSettingAfterProfile,
    });
  };

  const handleReject = () => {
    if (history.location.state?.from === "UserInfoSetting") {
      authStore.setAgeAgreedToUseUnder14(false);
      goBackToUserInfoSettingWithState(false);
      return;
    }
    history.goBack();
  };

  const handleScrollEnd = () => {
    // reserved for scroll-based validation if needed later
  };

  const handleGuardianConsentChange = (event) => {
    setIsGuardianConsentChecked(event.target.checked);
  };

  return (
    <SignInRoot>
      <TitleBox
        showBackButton={false}
        title={intl.formatMessage({ id: "guardian_consent_title" })}
        subtitle={intl.formatMessage({
          id: authStore.ageOver14 ? "guardian_consent_text_over14" : "guardian_consent_text",
        })}
      />
      <SignInContentsBox>
        <InfoBox mt={1}>
          <GuardianConsentTerms intl={intl} onScrollEnd={handleScrollEnd} isOver14={authStore.ageOver14} />
          <Box sx={{ width: "100%", display: "flex", alignItems: "flex-start"}}>
            <Checkbox
              checked={isGuardianConsentChecked}
              onChange={handleGuardianConsentChange}
              checkedIcon={<CheckIcon />}
              icon={<UnCheckIcon />}
              disableRipple
              sx={{ p: 0, mr: 1}}
            />
            <Typography variant="body2" sx={{ fontWeight: 700, wordBreak: "keep-all" }}>
              {intl.formatMessage({
                id: authStore.ageOver14 ? "guardian_consent_detail_txt07_over14" : "guardian_consent_detail_txt07",
              })}
            </Typography>
          </Box>
        </InfoBox>
        <ButtonContainer>
          <CommonButton
            text={intl.formatMessage({ id: "guardian_consent_btn_disagree" })}
            border={"#bfbfbf"}
            color={"#333"}
            onClick={handleReject}
            style={{ marginTop: '8px' }}
          />
          <CommonButton
            text={intl.formatMessage({ id: "guardian_consent_btn" })}
            background={"#FDD751"}
            color={"#333"}
            onClick={handleSubmit}
            disabled={!isGuardianConsentChecked}
          />
        </ButtonContainer>
      </SignInContentsBox>
    </SignInRoot>
  );
}

export default injectIntl(inject("authStore")(observer(GuardianConsent)));